import React from "react";
import "./style.css";

function FAQSection() {
  const tableData = [
    { length: "2,5 метр", price: "30 000" },
    { length: "3 метр", price: "35 000" },
    { length: "3,5 метр", price: "40 000" },
    { length: "4 метр", price: "45 000" },
    { length: "4,5 метр", price: "50 000" },
    { length: "5 метр", price: "55 000" },
    { length: "5,5 метр", price: "60 000" },
    { length: "6 метр", price: "65 000" },
    { length: "6,5 метр", price: "70 000" },
  ];
  const chairData = [
    { length: "2,5 метр", chairs: "12 стул" },
    { length: "3 метр", chairs: "14 стул" },
    { length: "3,5 метр", chairs: "16 стул" },
    { length: "4 метр", chairs: "18 стул" },
    { length: "4,5 метр", chairs: "20 стул" },
    { length: "5 метр", chairs: "20-22 стул" },
    { length: "5,5 метр", chairs: "22 стул" },
    { length: "6 метр", chairs: "24 стул" },
    { length: "6,5 метр", chairs: "26 стул" },
    { length: "7 метр", chairs: "28 стул" },
    { length: "7,5 метр", chairs: "30 стул" },
  ];
  return (
    <div>
      <div className="faq-section p-6 bg-center bg-no-repeat text-white shadow-md mb-6 mx-6 ">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <h2 className="text-lg font-bold mb-4">Столдордун баасы</h2>
        <table className="w-full border-collapse border border-[#6eb3b8] text-sm">
          <thead>
            <tr>
              <th className="border border-white px-4 py-2 text-left">
                Столдун узундугу
              </th>
              <th className="border border-white px-4 py-2 text-left">
                Баасы (сом)
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "" : ""}>
                <td className="border border-white px-4 py-2">{row.length}</td>
                <td className="border border-white px-4 py-2">{row.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="p-6 mt-8 faq-section-1 bg-center bg-no-repeat text-white mx-6 shadow-md">
      <div className="absolute inset-0 bg-black opacity-50"></div>
        <h2 className="text-lg font-bold mb-4">
          Стулдардын санын эсептөө (столдун метрлери боюнча)
        </h2>
        <table className="w-full border-collapse border border-white text-sm">
          <thead>
            <tr>
              <th className="border border-white px-4 py-2 text-left">
                Столдун узундугу
              </th>
              <th className="border border-white px-4 py-2 text-left">
                Стулдардын саны
              </th>
            </tr>
          </thead>
          <tbody>
            {chairData.map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "" : ""}>
                <td className="border border-white px-4 py-2">{row.length}</td>
                <td className="border border-white px-4 py-2">{row.chairs}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div class="flex flex-col items-center justify-center p-6">
        <h1 className="text-center text-3xl font-semibold mb-16">
          Стол жана стул заказга: Кажи-Сай кардарынын ой-пикири
        </h1>
        <div class="relative w-full" style={{ paddingBottom: "56.25%" }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/u8y0XtKEsec?si=YyrVJpEwREPPbkMU"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <section className="flex flex-col justify-center items-center special-offer mb-6 mt-12 px-8 bg-gradient-to-r from-[#326569] via-white to-[#326569] py-8 sm:px-8">
          <h2 className="section-title text-2xl mb-4 text-center font-bold">
            Улуттук каада-салт жана майрамдык атмосфера
          </h2>
          <p className="font-semibold text-xl">
            Дасторконго кыргыздын улуттук каадасын жана меймандостукту кошуп,
            майрамыңызды сапаттуу, заманбап эмеректер менен толтуруңуз! Эгерде
            сиз элеганттык, сапат жана узакка чыдамдуу эмерекке муктаж болсоңуз,
            анда бул сунуш сиз үчүн!
          </p>
          <p className="mt-4 font-semibold text-xl">
            Идеалдуу стол жана стулду азыр эле заказ кылып, майрамдарыңызга
            өзгөчө атмосфераны тартуулаңыз!
          </p>
          <p className="mt-4 font-semibold text-xl">
            Заказ берүү үчүн биз менен байланышып, үйүңүздү кооздоп алыңыз!
          </p>
          <div className="flex justify-center px-4">
            <button
              onClick={() => window.open("https://wa.me/996707178620", "_blank")}
              className="whatsapp-button text-[16px] py-[16px] px-[32px] mt-6 bg-red-600 text-white font-bold rounded-lg shadow-md hover:bg-green-600 transition"
            >
              Биз менен байланышып, заказ бериңиз
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default FAQSection;
